import React, {useMemo, useState} from 'react';
import moment from "moment";
import ReactTable from "react-table";


const columns = [
    {
        Header: 'General',
        columns: [
            {Header: "Account", accessor: 'detailacct'},
            {
                Header: "Date", Cell: ({original}) => {
                    return moment(original).format('YYYY-MM-DD');
                }
            },
            {Header: 'Lab', accessor: 'detaillabid'},
            {Header: 'Order', accessor: 'detailorder'},
        ]
    },
    {
        Header: 'Left',
        columns: [
            {Header: "Material", accessor: 'detailmatlt'},
            {Header: "Style", accessor: 'detailstylelt'}
        ]
    },
    {
        Header: 'Right',
        columns: [
            {Header: "Material", accessor: 'detailmatrt'},
            {Header: "Style", accessor: 'detailstylert'}
        ]
    }
];

export default ({original}) => {
    const [loading, setLoading] = useState(true);
    const [details, setDetails] = useState([]);
    const detailReq = useMemo(async () => {
        const resp = await fetch(`/webservice/dashboard/detail?labid=${original.summarylabid}&date=${original.summarydate}&acct=${original.summaryacct}`);
        return await resp.json();
    }, [original.summaryacct, original.summarylabid, original.summarydate]);
    console.log(original);
    detailReq.then(json => {
        setDetails(json);
        setLoading(false);
        console.log(json);
    }).catch(() => setLoading(false));
    return (
        <div style={{padding: '20px'}}>
            <ReactTable
                loading={loading}
                data={details}
                columns={columns}
            />
        </div>
    );
}
